import { render, staticRenderFns } from "./AddUpdatePage.vue?vue&type=template&id=2a9530d8&scoped=true&"
import script from "./AddUpdatePage.vue?vue&type=script&lang=js&"
export * from "./AddUpdatePage.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdatePage.vue?vue&type=style&index=0&id=2a9530d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9530d8",
  null
  
)

export default component.exports